module.exports = __webpack_public_path__ + "img/1895_Rotationsdruckmaschine.f03fe787.jpg";